import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { FileText, Loader2, Plus } from "lucide-react";
import { api } from "../../lib/api";

export const OrderList = () => {
  const { data, isLoading } = useQuery({ queryKey: ["orders"], queryFn: () => api.get("/admin/orders").then((r) => r.data) });
  const rows = Array.isArray(data) ? data : [];
  return (
    <div className="space-y-4" data-testid="orders-list">
      <Link to="/admin/orders/new" className="inline-flex items-center gap-2 rounded-full bg-gold-foil px-5 py-2.5 text-sm font-semibold text-[#240620]" data-testid="new-order-note-btn"><Plus size={15} /> New order note</Link>
      {isLoading ? <Loader2 className="animate-spin text-[#F3E5AB]" /> : rows.length === 0 ? (
        <p className="text-[#E8D8C8]" data-testid="orders-empty">No order notes yet. Open an enquiry and tap "Create order note" once the customer confirms on WhatsApp.</p>
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {rows.map((o, i) => (
            <Link key={o.id} to={`/admin/orders/${o.id}`} className="flex items-center gap-4 rounded-2xl border border-[#D4AF37]/20 bg-[#330B2E]/70 p-4 hover:border-[#D4AF37]" data-testid={`order-row-${i}`}>
              <FileText className="text-[#D4AF37]" />
              <div className="min-w-0 flex-1">
                <p className="truncate font-display text-2xl">{o.customer}</p>
                <p className="text-sm text-[#E8D8C8]">{o.occasion || "-"} · {o.event_date || "-"} · {(o.items || []).length} item(s)</p>
              </div>
              <span className="rounded-full bg-[#25D366]/15 px-3 py-1 text-xs text-[#25D366]">{o.status}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};
